import React, { useEffect, useState } from 'react';
import { authService } from '../../utils/authService';
import BusySpinner from '../spinners/BusySpinner';
import getClientConfig from "../../utils/getClientConfig";
import { setAccessToken, setRefreshToken, setIdToken } from '../../utils/tokenStorage';
import { FeatureFlagEnum } from '../../utils/enums';
import REST_CLIENT from '../../utils/restClient';

function CallbackPage() {
    const [error, setError] = useState(null);
    const { aiEndSessionUrl } = getClientConfig();

    useEffect(() => {
        const handleCallback = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const code = params.get('code');
                const state = params.get('state');

                // Check for logout state
                const logoutState = localStorage.getItem('logout_state');

                if (logoutState === 'true') {
                    // Clear logout state
                    localStorage.removeItem('logout_state');
                    // Redirect to home or login page
                    window.location.href = aiEndSessionUrl;
                    return;
                }

                if (code && state) {
                    await handleAuthenticatedCallback(code, state);
                }
                else {
                    throw new Error('No code or state parameter found');
                }
            } catch (error) {
                setError(error.message);
            }
        };

        handleCallback();
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    return <BusySpinner busy={true} />;
}

const handleAuthenticatedCallback = async (code, state) => {
    const tokens = await authService.handleRedirect(code, state);

    // Auto-retry path: handleRedirect may have initiated a new login and returned nothing
    if (!tokens) {
        return;
    }

    // Store tokens
    setAccessToken(tokens.access_token);
    setIdToken(tokens.id_token);
    if (tokens.refresh_token) {
        setRefreshToken(tokens.refresh_token);
    }

    const redirectUrl = await getRedirectUrlAsync(state);
    if (redirectUrl !== null) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = window.location.origin;
    }
};

const getFeatureFlagsAsync = async () => {
  try {
      const flags = await REST_CLIENT.getFeatureFlags();
      return flags.reduce((acc, flag) => {
          acc[flag.name] = flag.value;
          return acc;
      }, {});
  } catch {
      return {};
  }
}

const getRedirectUrlAsync = async (state) => {
    // Check if user tried to navigate somewhere other than the root before login
  
    // Expected format of state 'nonce::path::{pathvalue}::query::{queryvalue}::end'
    const pathMatch = state.match(/::path::(.*?)::query::/);
    const queryMatch = state.match(/::query::(.*?)::end/);

    const path = pathMatch ? pathMatch[1] : null;
    const query = queryMatch ? queryMatch[1] : null;

    if (path && path !== '/' && path !== '\\') {
        // Redirect user back to pre-login path
        return query ? `${window.location.origin}${path}?${query}` : `${window.location.origin}${path}`
    }

    // Note: at this point - featureFlags have not yet been attached to window.appConfig so explicitly load them
    const featureFlags = await getFeatureFlagsAsync();                        
    if (featureFlags?.[FeatureFlagEnum.ENABLE_COMPLIANCE_CALENDAR_AS_HOME_PAGE]) {
      const { complianceCalendarUrl } = getClientConfig();
      return complianceCalendarUrl || null;
    }

    return null;
}

export default CallbackPage;